import { CaseGranulometry } from '../../CaseGranulometry';
import { LevelGranulometry } from '../../../levels/LevelGranulometry';
import { getCaseTopLevels } from './getCaseTopLevels';

export const getCaseLargestTopLevel = (caseGranulometry: CaseGranulometry): LevelGranulometry =>
  getCaseTopLevels(caseGranulometry).reduce(
    (largestLevel, level) => (level.surface > largestLevel.surface ? level : largestLevel),
    { surface: 0 } as LevelGranulometry
  );
